module.exports = __webpack_public_path__ + "static/header1-994342c506420ee97f58789e1b3ab728.jpg";